import * as React from 'react';
import FinancialFilingDataGrid from './FinancialFilingDataGrid';

function TenKFilings({filings} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Annual 10-K filings</h4>
          <p className="card-description">
            Select a 10-K (Annual Report) to analyze and review with our AI assistant.
          </p>
          <div>
            { filings?.data['10-K']?.length > 0  ?
              <FinancialFilingDataGrid
                data={filings.data['10-K']}
              />
            : <p className="card-description">There are no 10-K filings available</p> }
          </div>
        </div>
      </div>
    </div>
  );
}

export default TenKFilings;
